// extracted by mini-css-extract-plugin
export default {"header":"PortalHeader__header__ph0hV","light":"PortalHeader__light__OgmEB","logo":"PortalHeader__logo__HWQCt","title":"PortalHeader__title__cH4ZS"};